import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Style from './PlaybackError.module.scss';

const PlaybackError = ({ sharedTheme, children, rendered, backgroundInline }) => {
  if (!rendered) return null;

  const innerContainerStyle = backgroundInline ? { ...backgroundInline } : null;
  return (
    <div className={classNames(sharedTheme.container, Style.container)}>
      <div
        className={classNames(sharedTheme.innerContainer, Style.innerContainer)}
        style={innerContainerStyle}
      >
        <div className={Style.content}>{children}</div>
      </div>
    </div>
  );
};

PlaybackError.propTypes = {
  sharedTheme: PropTypes.shape({}),
  rendered: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  backgroundInline: PropTypes.shape({}),
};

PlaybackError.defaultProps = {
  sharedTheme: {},
  rendered: false,
  children: null,
  backgroundInline: {},
};
export default PlaybackError;
